// ✅ Home.jsx (with stars rendered)
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

export default function Home() {
  const [reviews, setReviews] = useState([]);
  const [currentReview, setCurrentReview] = useState(0);

  useEffect(() => {
	fetch('https://api.jazuzmovingcompany.com/api/custom-reviews')
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) setReviews(data);
      })
      .catch((err) => console.error('Error fetching reviews:', err));
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentReview((prev) => (prev + 1) % (reviews.length || 1));
    }, 5000);
    return () => clearInterval(interval);
  }, [reviews]);

  const renderStars = (count) => {
    return [...Array(5)].map((_, i) => (
      <span key={i} style={{ color: i < count ? '#FFD700' : '#ccc' }}>★</span>
    ));
  };

  return (
    <div
      className="text-white"
      style={{
        backgroundImage: `url('/Jazuz-moving-truck.png')`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        minHeight: '100vh',
        backgroundAttachment: 'fixed',
      }}
    >
      <div className="container bg-dark bg-opacity-75 p-5 rounded text-center animate__animated animate__fadeInDown">
        <h1 className="display-4 text-warning mb-3 fw-bold">Stress-Free Moving Starts Here</h1>
        <p className="lead mb-4">Professional. Reliable. Nationwide.</p>

        <div className="d-flex justify-content-center gap-3 mb-5 flex-wrap">
          <Link to="/services" className="btn btn-outline-warning btn-lg fw-semibold px-4">
            Explore Services
          </Link>
          <Link to="/quote" className="btn btn-warning btn-lg fw-semibold px-4 text-dark">
            Get a Quote
          </Link>
        </div>

        <div className="row g-4 mb-5">
          <div className="col-md-4">
            <div className="card bg-secondary bg-opacity-25 border-0 h-100 p-3">
              <h5 className="text-warning">📦 Full-Service Moving</h5>
              <p className="text-white small">From packing to delivery, we handle it all with care and efficiency.</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card bg-secondary bg-opacity-25 border-0 h-100 p-3">
              <h5 className="text-warning">🕒 Timely Delivery</h5>
              <p className="text-white small">We stick to schedule—so you can plan ahead without stress.</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card bg-secondary bg-opacity-25 border-0 h-100 p-3">
              <h5 className="text-warning">💼 Trusted Professionals</h5>
              <p className="text-white small">Our movers are trained, vetted, and customer-focused.</p>
            </div>
          </div>
        </div>


        {/* 💬 Testimonial Slider */}
        <div className="bg-secondary bg-opacity-25 p-4 rounded">
          <h4 className="text-warning mb-4">What Our Customers Say</h4>
          {reviews.length > 0 ? (
            <div className="card bg-dark bg-opacity-50 border-0 p-4 mx-auto" style={{ maxWidth: '700px' }}>
              <p className="text-white small">"{reviews[currentReview].text}"</p>
              <p className="text-warning fw-bold mb-0">– {reviews[currentReview].author_name}</p>
              <p className="text-white small">{renderStars(reviews[currentReview].rating)}</p>
            </div>
          ) : (
            <p className="text-white small">No reviews available right now. Please check back later.</p>
          )}
        </div>
      </div>
    </div>
  );
}
